<div
  class="chat-step-wrapper"
  [ngClass]="stepCssClasses"
  *ngIf="step && flowDesign"
>
  <div
    class="text-help agent-message-name"
    style="padding-left: 84px; font-size: 12px; margin-bottom: 5px"
    [@fadeIn]
    [style.opacity]="agentIconOpacity"
  >
    {{ flowDesign.bot_name }}
  </div>
  <div class="agent-messages-wrapper" style="display: flex; position: relative">
    <div
      #agentWrapper
      style="
        display: flex;
        justify-content: center;
        align-items: end;
        height: 56px;
        width: 56px;
        margin: 0 10px 5px 0px;
      "
      [ngStyle]="{
        transform: 'translateY(' + offsetY + 'px)',
        transition: 'transform 0.4s ease-in'
      }"
    >
      <img
        class="agent-icon"
        [src]="flowDesign.avatars.selected"
        height="auto"
        width="auto"
        style="max-height: 72px; max-width: 56px"
        [style.opacity]="agentIconOpacity"
        [alt]="flowDesign.bot_name + ', Chatbot'"
      />
      <loading-dots *ngIf="!allAgentMessagesDisplayed"></loading-dots>
    </div>
    <div style="display: flex; flex-direction: column" #messagesContainer>
      <div
        *ngFor="
          let message of displayedMessages;
          trackBy: trackByFn;
          let isLast = last
        "
      >
        <ng-container *ngIf="message && currentLang">
          <agent-message-field
            #activeQuestionMessage
            [message]="message.message[currentLang]"
            [messageId]="isLast ? activeQuestionMessageId : null"
            [focusable]="isLast && shouldFocusQuestionFirst"
          ></agent-message-field>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- [isLoading]="isLoading" -->
  <user-message-field
    *ngIf="userMessage && currentLang"
    [userMessage]="userMessage"
    [currentLang]="currentLang"
    [textAlignment]="
      step.type === stepType.CONTACT_FORM || stepType.FEEDBACK ? 'start' : 'end'
    "
  ></user-message-field>

  <!-- Steps restored as already answered never re-render their options, so old
       questions can't be re-submitted and can't replay an auto-advance. -->
  <user-options
    *ngIf="allAgentMessagesDisplayed && currentLang && !restoredAnswer"
    [step]="step"
    [currentLang]="currentLang"
    [controlAutoFocusEnabled]="shouldAutoFocusFirstControl"
    [questionLabelledBy]="activeQuestionMessageId"
    [isLastStep]="isLastStep"
    [primaryOptionsDisabled]="isAiTextAnswerMissing"
    (buttonClicked)="setNextStep($event.option, $event.errorMessage)"
    (countdownMessage)="onCountdownMessage($event)"
    [testMode]="testMode"
  >
    <ng-container *ngIf="step.type === stepType.FEEDBACK">
      <feedback-step-inputs
        [step]="step"
        [currentLang]="currentLang"
        [errorMessage]="errorMessage"
        [validationAttempt]="feedbackValidationAttempt"
      ></feedback-step-inputs>
    </ng-container>
    <ng-container *ngIf="step.type === stepType.AI_FEEDBACK">
      <div style="padding: 0 15px">
        <ai-feedback-inputs
          [step]="step"
          [currentLang]="currentLang"
          (textAnswerValidityChange)="hasAiTextAnswer = $event"
        ></ai-feedback-inputs>
      </div>
      <!-- (feedbackTextArea)="onFeedbackTextArea($event, i)" -->
    </ng-container>

    <ng-container *ngIf="step.type === stepType.CONTACT_FORM">
      <div style="padding: 0px 15px">
        <user-input-contact-fields
          [inputs]="step.additional_config.contact_fields"
          (inputValue)="onContactFieldValueChange($event)"
          [currentLang]="currentLang"
        ></user-input-contact-fields>
      </div>
    </ng-container>
    <ng-container *ngIf="step.type === stepType.EMPLOYEE_SELECTION">
      <div style="padding: 0px 15px">
        <user-employee-selection
          [employees]="step.additional_config.employees"
          (onChangeEmployee)="submitEmployeeSelection($event)"
        ></user-employee-selection>
      </div>
    </ng-container>
  </user-options>
  <!-- stepType.GOODBYE Countdown message for goodbye steps  -->
  <div
    *ngIf="countdownMessage"
    class="agent-messages-wrapper"
    style="display: flex; position: relative"
  >
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: end;
        height: 56px;
        width: 56px;
        margin: 0 10px 5px 0px;
      "
    >
      <img
        class="agent-icon"
        [src]="flowDesign.avatars.selected"
        height="auto"
        width="auto"
        style="max-height: 72px; max-width: 56px"
        [alt]="flowDesign.bot_name + ', Chatbot'"
      />
    </div>
    <agent-message-field [message]="countdownMessage"></agent-message-field>
  </div>
</div>
<ng-container *ngIf="isLoading && step && step.type === stepType.AI_FEEDBACK">
  <div
    class="text-help agent-message-name"
    style="font-size: 12px; margin-bottom: 5px; margin-left: 20px"
    [@fadeIn]
  >
    <div
      #agentWrapper
      style="
        display: flex;
        justify-content: center;
        align-items: end;
        height: 56px;
        width: 56px;
        margin: 0 10px 5px 0;
      "
      [ngStyle]="{
        transform: 'translateY(' + offsetY + 'px)',
        transition: 'transform 0.4s ease-in'
      }"
    >
      <img
        class="agent-icon"
        [src]="flowDesign!.avatars.selected"
        height="auto"
        width="auto"
        style="max-height: 72px; max-width: 56px"
        [alt]="flowDesign!.bot_name + ', Chatbot'"
      />
      <loading-dots *ngIf="isLoading"></loading-dots>
    </div>
  </div>
</ng-container>
